import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getBuildingHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "Building", ...action.payload }),
		);
		yield put({
			type: types.GET_BUILDING_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_BUILDING_ERROR,
			payload,
		});
	}
}

export function* getBuildingWatcherSaga() {
	yield takeLatest(types.GET_BUILDING_START, getBuildingHandlerSaga);
}

//create

//delete

function* deleteBuildingHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("Building", action.payload),
		);
		yield put({
			type: types.DELETE_BUILDING_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_BUILDING_ERROR,
			payload,
		});
	}
}

export function* deleteBuildingWatcherSaga() {
	yield takeLatest(types.DELETE_BUILDING_START, deleteBuildingHandlerSaga);
}

//update
